/*
 * Buy it now（VEWO 版，10/23 重写，照 FEPPO 新版调整）
 * 旧版：读购物车 → 清空购物车（把客人原来的东西存进 localStorage 的 HAPAW_saved_cart，回来再由 cart-restore.js 清空重加）→ 加商品 → 轮询 3×300ms 等赠品 → 再等 500ms → 结账。
 * 新版（用户 10/23 定：不再清空、不再恢复）：
 *   - 购物车是空的：加这一件 → 去结账。
 *   - 购物车里已有别的东西：只做普通加购，然后去购物车页，不替客人决定结账哪些。
 *   - 全程不调用 cart/clear.js，不写 localStorage。
 * VEWO 与 FEPPO 的区别：VEWO 没有赠品应用（10/23 实测加购一件后购物车 4 次检查都只有 1 件），
 * 所以 giftWaitAttempts = 0，不再等赠品。以后如果装了赠品应用，把它改成 2 即可（最多等 2×250ms，数量一变多立刻走）。
 */
class BuyNowWithGift {
  constructor() {
    this.giftWaitAttempts = 0;
    this.giftWaitInterval = 250;
    this.init();
  }

  getRouteRoot() {
    const shopifyRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    const themeRoot = window.theme && window.theme.routes && window.theme.routes.root_url;
    const root = shopifyRoot || themeRoot || "/";
    return root.endsWith("/") ? root : `${root}/`;
  }

  getCartEndpoint(path) {
    return this.getRouteRoot() + path.replace(/^\//, "");
  }

  getCheckoutUrl() {
    return this.getRouteRoot() + "checkout";
  }

  init() {
    document.addEventListener("click", (event) => {
      const button = event.target.closest(".buy-now-button");
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        this.handleBuyNow({ currentTarget: button });
      }
    });
  }

  async getCart() {
    return (await fetch(this.getCartEndpoint("cart.js"), { cache: "no-store" })).json();
  }

  notifyCart(cart) {
    document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { cart } }));
    if (window.dispatchEvent) window.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart } }));
  }

  async handleBuyNow(event) {
    const button = event.currentTarget;
    const form = document.getElementById(button.dataset.formId);
    if (!form) {
      console.error("[Buy Now] Form not found:", button.dataset.formId);
      return;
    }
    if (button.disabled) return;

    try {
      this.updateButtonState(button, "adding");
      const before = await this.getCart();
      const hadOtherItems = before.item_count > 0;

      const formData = new FormData(form);
      const variantId = formData.get("id");
      const quantity = parseInt(formData.get("quantity")) || 1;
      const addResponse = await fetch(this.getCartEndpoint("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!addResponse.ok) {
        const errorData = await addResponse.json();
        throw new Error(errorData.description || "Failed to add to cart");
      }

      let cart = await this.getCart();
      this.notifyCart(cart);

      if (hadOtherItems) {
        // 客人购物车里本来就有东西：只加购，去购物车页让客人自己确认
        this.updateButtonState(button, "redirecting");
        window.location.href = this.getRouteRoot() + "cart";
        return;
      }

      // 空购物车：如果有赠品应用，给它一个很短的窗口把赠品加进来，数量一变多立刻往下走（VEWO 目前为 0 次，直接结账）
      if (this.giftWaitAttempts > 0) {
        this.updateButtonState(button, "preparing");
        for (let i = 0; i < this.giftWaitAttempts; i++) {
          await this.wait(this.giftWaitInterval);
          const check = await this.getCart();
          if (check.item_count > cart.item_count) {
            cart = check;
            break;
          }
        }
      }

      this.updateButtonState(button, "redirecting");
      window.location.href = this.getCheckoutUrl();
    } catch (error) {
      console.error("[Buy Now] Error:", error);
      this.showError(button, error.message || "Something went wrong. Please try again.");
      setTimeout(() => {
        this.updateButtonState(button, "default");
      }, 3000);
    }
  }

  updateButtonState(button, state) {
    ["default", "adding", "preparing", "redirecting"].forEach((s) => {
      const element = button.querySelector(`.buy-now-button--${s}`);
      if (element) element.style.display = "none";
    });
    const loadingSpinner = button.querySelector(".loading-overlay");
    if (loadingSpinner) loadingSpinner.style.display = state !== "default" ? "block" : "none";
    const currentStateElement = button.querySelector(`.buy-now-button--${state}`);
    if (currentStateElement) currentStateElement.style.display = "block";
    button.disabled = state !== "default";
  }

  showError(button, message) {
    let errorContainer = button.parentElement.querySelector(".buy-now-error");
    if (!errorContainer) {
      errorContainer = document.createElement("div");
      errorContainer.className = "buy-now-error form-notification error";
      errorContainer.style.cssText = "margin-top: 10px; padding: 10px; background: #fee; border: 1px solid #fcc; border-radius: 4px; color: #c00;";
      button.parentElement.appendChild(errorContainer);
    }
    errorContainer.textContent = message || "Something went wrong. Please try again.";
    errorContainer.style.display = "block";
    setTimeout(() => {
      if (errorContainer) errorContainer.style.display = "none";
    }, 5000);
  }

  wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new BuyNowWithGift();
  });
} else {
  new BuyNowWithGift();
}
